import { defineMessage } from 'react-intl'
import {
    GlobalStep,
    Step,
    CreatorAccommodationStep,
    SelfcareStep,
    UnlimitedCardStep,
    UnlimitedRenewStep,
    VouchersStep,
} from 'store/general-slice/types'

type StepObject = {
    title: {
        id: string
        defaultMessage: string
    }
    slug: {
        pl: string
        en: string
        uk: string
    }
    subPaths?: string[] // for additional, nested, but mostly functional paths (ex. url 'params')
    navigationIndex: number | null
}

export interface CreatorStepObject extends StepObject {
    id: Step
}

export interface CreatorAccommodationStepObject extends StepObject {
    id: CreatorAccommodationStep
}

export interface SelfcareStepObject extends StepObject {
    id: SelfcareStep
}

export interface UnlimitedCardStepObject extends StepObject {
    id: UnlimitedCardStep
}

export interface UnlimitedRenewStepObject extends StepObject {
    id: UnlimitedRenewStep
}

export interface VouchersStepObject extends StepObject {
    id: VouchersStep
}

export interface GlobalStepObject extends StepObject {
    id: GlobalStep
}

//@TODO refactor

// basename: /pl/kreator | /en/creator
export const STEPS: CreatorStepObject[] = [
    {
        id: 'tickets',
        title: defineMessage({
            id: 'global.steps.caption_tickets',
            defaultMessage: 'Bilety',
        }),
        slug: {
            pl: '/',
            en: '/',
            uk: '/',
        },
        subPaths: ['/family'],
        navigationIndex: 1,
    },
    {
        id: 'upsell',
        title: defineMessage({
            id: 'global.steps.caption_upsells',
            defaultMessage: 'Udogodnienia i atrakcje',
        }),
        slug: {
            pl: '/udogodnienia-i-atrakcje',
            en: '/facilities-and-activities',
            uk: '/facilities-and-activities',
        },
        navigationIndex: 2,
    },
    {
        id: 'accommodation',
        title: defineMessage({
            id: 'global.steps.caption_accommo',
            defaultMessage: 'Nocleg',
        }),
        slug: {
            pl: '/zakwaterowanie',
            en: '/accommodation',
            uk: '/accommodation',
        },
        navigationIndex: 3,
    },
    {
        id: 'accommodation_details',
        title: defineMessage({
            id: 'global.steps.caption_accommo',
            defaultMessage: 'Nocleg',
        }),
        slug: {
            pl: '/szczegoly-zakwaterowania',
            en: '/accommodation-details',
            uk: '/accommodation-details',
        },
        navigationIndex: null,
    },
    {
        id: 'order',
        title: defineMessage({
            id: 'global.steps.caption_order',
            defaultMessage: 'Zamówienie i płatność',
        }),
        slug: {
            pl: '/zamowienie-i-platnosc',
            en: '/order-and-payment',
            uk: '/order-and-payment',
        },
        navigationIndex: 4,
    },
]

// basename: /pl/kreator-zakwaterowanie | /en/creator-accommodation
export const CREATOR_ACCOMMODATION_STEPS: CreatorAccommodationStepObject[] = [
    {
        id: 'accommodation',
        title: defineMessage({
            id: 'global.steps.caption_accommo',
            defaultMessage: 'Nocleg',
        }),
        slug: {
            pl: '/',
            en: '/',
            uk: '/',
        },
        navigationIndex: 1,
    },
    {
        id: 'accommodation_details',
        title: defineMessage({
            id: 'global.steps.caption_accommo',
            defaultMessage: 'Nocleg',
        }),
        slug: {
            pl: '/szczegoly-zakwaterowania',
            en: '/accommodation-details',
            uk: '/accommodation-details',
        },
        navigationIndex: null,
    },
    {
        id: 'tickets',
        title: defineMessage({
            id: 'global.steps.caption_tickets',
            defaultMessage: 'Bilety',
        }),
        slug: {
            pl: '/bilety-do-parku',
            en: '/park-tickets',
            uk: '/park-tickets',
        },
        navigationIndex: 2,
    },
    {
        id: 'upsell',
        title: defineMessage({
            id: 'global.steps.caption_upsells',
            defaultMessage: 'Udogodnienia i atrakcje',
        }),
        slug: {
            pl: '/udogodnienia-i-atrakcje',
            en: '/facilities-and-activities',
            uk: '/facilities-and-activities',
        },
        navigationIndex: 3,
    },
    {
        id: 'order',
        title: defineMessage({
            id: 'global.steps.caption_order',
            defaultMessage: 'Zamówienie i płatność',
        }),
        slug: {
            pl: '/zamowienie-i-platnosc',
            en: '/order-and-payment',
            uk: '/order-and-payment',
        },
        navigationIndex: 4,
    },
]

// basename: /pl/zarzadzaj-zamowieniem | /en/manage-order
export const SELFCARE_STEPS: SelfcareStepObject[] = [
    {
        id: 'starter',
        title: defineMessage({
            id: 'global.steps.caption_selfcare_starter',
            defaultMessage: 'Starter',
        }),
        slug: {
            pl: '/',
            en: '/',
            uk: '/',
        },
        navigationIndex: null,
    },
    {
        id: 'edit_order',
        title: defineMessage({
            id: 'global.steps.caption_selfcare_manage_order',
            defaultMessage: 'Zarządzaj rezerwacją',
        }),
        slug: {
            pl: '/edytuj-rezerwacje',
            en: '/edit-order',
            uk: '/edit-order',
        },
        navigationIndex: 1,
    },
    {
        id: 'summary',
        title: defineMessage({
            id: 'global.steps.caption_summary',
            defaultMessage: 'Podsumowanie',
        }),
        slug: {
            pl: '/podsumowanie',
            en: '/summary',
            uk: '/summary',
        },
        navigationIndex: 2,
    },
    {
        id: 'selfcare_order',
        title: defineMessage({
            id: 'global.steps.caption_order',
            defaultMessage: 'Zamówienie i płatność',
        }),
        slug: {
            pl: '/zamowienie-i-platnosc',
            en: '/order-and-payment',
            uk: '/order-and-payment',
        },
        navigationIndex: 3,
    },
]

// basename: /pl/karta-caloroczna | /en/unlimited-card
export const UNLIMITED_CARD_STEPS: UnlimitedCardStepObject[] = [
    {
        id: 'card_configuration',
        title: defineMessage({
            id: 'global.steps.caption_unlimited_card_configuration',
            defaultMessage: 'Konfiguracja karty',
        }),
        slug: {
            pl: '/',
            en: '/',
            uk: '/',
        },
        navigationIndex: 1,
    },
    {
        id: 'card_summary',
        title: defineMessage({
            id: 'global.steps.caption_summary',
            defaultMessage: 'Podsumowanie',
        }),
        slug: {
            pl: '/podsumowanie',
            en: '/summary',
            uk: '/summary',
        },
        navigationIndex: 2,
    },
    {
        id: 'card_order',
        title: defineMessage({
            id: 'global.steps.caption_order',
            defaultMessage: 'Zamówienie i płatność',
        }),
        slug: {
            pl: '/zamowienie-i-platnosc',
            en: '/order-and-payment',
            uk: '/order-and-payment',
        },
        navigationIndex: 3,
    },
]

// basename: /pl/odnow-karte | /en/renew-card
export const UNLIMITED_RENEW_STEPS: UnlimitedRenewStepObject[] = [
    {
        id: 'renew_verification',
        title: defineMessage({
            id: 'global.steps.caption_unlimited_renew_verification',
            defaultMessage: 'Podaj numer karty',
        }),
        slug: {
            pl: '/',
            en: '/',
            uk: '/',
        },
        navigationIndex: 1,
    },
    {
        id: 'renew_summary',
        title: defineMessage({
            id: 'global.steps.caption_unlimited_renew_summary',
            defaultMessage: 'Twoja nowa karta',
        }),
        slug: {
            pl: '/podsumowanie',
            en: '/summary',
            uk: '/summary',
        },
        navigationIndex: 2,
    },
    {
        id: 'renew_order',
        title: defineMessage({
            id: 'global.steps.caption_order',
            defaultMessage: 'Zamówienie i płatność',
        }),
        slug: {
            pl: '/zamowienie-i-platnosc',
            en: '/order-and-payment',
            uk: '/order-and-payment',
        },
        navigationIndex: 3,
    },
]

// basename: /pl/kreator-vouchery | /en/vouchers-creator
export const VOUCHERS_STEPS: VouchersStepObject[] = [
    {
        id: 'vouchers_configuration',
        title: defineMessage({
            id: 'global.steps.caption_vouchers_configuration',
            defaultMessage: 'Konfiguracja vouchera',
        }),
        slug: {
            pl: '/',
            en: '/',
            uk: '/',
        },
        navigationIndex: 1,
    },
    {
        id: 'vouchers_summary',
        title: defineMessage({
            id: 'global.steps.caption_summary',
            defaultMessage: 'Podsumowanie',
        }),
        slug: {
            pl: '/podsumowanie',
            en: '/summary',
            uk: '/summary',
        },
        navigationIndex: 2,
    },
    {
        id: 'vouchers_order',
        title: defineMessage({
            id: 'global.steps.caption_order',
            defaultMessage: 'Zamówienie i płatność',
        }),
        slug: {
            pl: '/zamowienie-i-platnosc',
            en: '/order-and-payment',
            uk: '/order-and-payment',
        },
        navigationIndex: 3,
    },
]

// basename: /pl/app | /en/app
export const GLOBAL_STEPS: GlobalStepObject[] = [
    {
        id: 'thankyou',
        title: defineMessage({
            id: 'global.steps.caption_thank_you',
            defaultMessage: 'Dziękujemy za wybór Suntago!',
        }),
        slug: {
            pl: '/potwierdzenie-zamowienia',
            en: '/order-confirmation',
            uk: '/order-confirmation',
        },
        navigationIndex: null,
    },
    {
        id: 'registration_confirmation',
        title: defineMessage({
            id: 'global.steps.caption_registration_thank_you',
            defaultMessage: 'Dziękujemy za stworzenie konta!',
        }),
        slug: {
            pl: '/potwierdzenie-konta',
            en: '/account-confirmation',
            uk: '/account-confirmation',
        },
        navigationIndex: null,
    },
    {
        id: 'activation_link_invalid',
        title: defineMessage({
            id: 'global.steps.caption_activation_link_invalid',
            defaultMessage: 'Link aktywacyjny jest nieprawidłowy.',
        }),
        slug: {
            pl: '/link-aktywacyjny-nieprawidlowy',
            en: '/activation-link-invalid',
            uk: '/activation-link-invalid',
        },
        navigationIndex: null,
    },
    {
        id: 'activation_link_expired',
        title: defineMessage({
            id: 'global.steps.caption_activation_link_expired',
            defaultMessage: 'Link aktywacyjny wygasł.',
        }),
        slug: {
            pl: '/link-aktywacyjny-wygasl',
            en: '/activation-link-expired',
            uk: '/activation-link-expired',
        },
        navigationIndex: null,
    },
    {
        id: 'account_active',
        title: defineMessage({
            id: 'global.steps.caption_account_activated',
            defaultMessage: 'Konto jest aktywowane!',
        }),
        slug: {
            pl: '/konto-potwierdzone',
            en: '/account-already-confirmed',
            uk: '/account-already-confirmed',
        },
        navigationIndex: null,
    },
    {
        id: 'maintenance',
        title: defineMessage({
            id: 'global.steps.caption_thank_you',
            defaultMessage: 'Dziękujemy za wybór Suntago!',
        }),
        slug: {
            pl: '/obsluga-techniczna',
            en: '/maintenance',
            uk: '/maintenance',
        },
        navigationIndex: null,
    },
    {
        id: 'payment_failed',
        title: defineMessage({
            id: 'global.steps.caption_payment_error',
            defaultMessage: 'Błąd płatności',
        }),
        slug: {
            pl: '/blad-platnosci',
            en: '/payment-failed',
            uk: '/payment-failed',
        },
        navigationIndex: null,
    },
    {
        id: 'payment',
        title: defineMessage({
            id: 'global.steps.caption_payment',
            defaultMessage: 'Płatność',
        }),
        slug: {
            pl: '/platnosc',
            en: '/payment',
            uk: '/payment',
        },
        navigationIndex: null,
    },
]
